export enum ClientPOStatus {
  Draft = 0,
  Submitted = 1,
  Approved = 2,
  InProduction = 3,
  PartiallyDispatched = 4,
  Dispatched = 5,
  Cancelled = 98,
  Deleted = 99,
}

export enum ClientPOType {
  Chemical = 0,
}
